import React, { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { Card, Row, Col, Typography, Input, Select, Button, Spin, DatePicker, Popover, Space, } from "antd";
import { FilePdfOutlined, FileExcelOutlined, DownloadOutlined, SearchOutlined, EyeOutlined, FilterOutlined, CalendarOutlined, } from "@ant-design/icons";
import dayjs from "dayjs";
import _consumerService from "../../../modules/consumerService";

const { Title, Text } = Typography;
const { RangePicker } = DatePicker;

const Reports = ({ consumerId }) => {
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [documents, setDocuments] = useState([]);

  // Filters
  const [search, setSearch] = useState("");
  const [docType, setDocType] = useState(null);
  const [dateRange, setDateRange] = useState(null);

  useEffect(() => {
    if (consumerId) {
      getConsumerReportByConsumerId();
    }
  }, [consumerId]);

  const getConsumerReportByConsumerId = async () => {
    try {
      setLoading(true);
      const res = await _consumerService.getConsumerReportByConsumerId(1);

      const list = res?.data?.listApplicantDocs || [];

      setDocuments(
        list.map((doc, index) => ({
          id: index + 1,
          name: doc.DocName,
          type: doc.DocType?.replace(".", "").toUpperCase(), // PDF / XLSX
          size:doc.DocSize,
          date: dayjs().format("YYYY-MM-DD"), // API doesn't provide date
          url: doc.DocPath,
          createdDate:doc.DocCreatedDate,
          updatedDate:doc.DocUpdatedDate,

        }))
      );
    } catch (error) {
      console.error("Failed to load reports", error);
    } finally {
      setLoading(false);
    }
  };

  /* ================= FILTERING ================= */
  const filteredDocuments = useMemo(() => {
    return documents.filter((doc) => {
      if (
        search &&
        !doc.name.toLowerCase().includes(search.toLowerCase())
      ) {
        return false;
      }

      if (docType && doc.type !== docType) {
        return false;
      }

      if (dateRange) {
        const d = dayjs(doc.date);
        if (
          d.isBefore(dateRange[0], "day") ||
          d.isAfter(dateRange[1], "day")
        ) {
          return false;
        }
      }

      return true;
    });
  }, [documents, search, docType, dateRange]);

  /* ================= ACTIONS ================= */
  const handleOpen = (doc) => {
    history.push(`/reportPreview/${doc.id}`, {
      consumerId,
    });
  };

  const handleDownload = (doc) => {
    if (!doc?.url) return;
    const link = document.createElement("a");
    link.href = doc.url;
    link.download = doc.name;
    link.target = "_blank"; // required for SAS URLs
    link.click();
  };

  /* ================= POPOVER CONTENT ================= */
  const filterContent = (
    <Select
      placeholder="Document type"
      value={docType}
      onChange={setDocType}
      allowClear
      style={{ width: 200 }}
      options={[
        { label: "PDF", value: "PDF" },
        { label: "Excel (XLSX)", value: "XLSX" },
      ]}
    />
  );

  const dateContent = (
    <RangePicker
      value={dateRange}
      onChange={setDateRange}
      allowClear
      style={{ width: 260 }}
    />
  );

  return (
    <Spin spinning={loading}>
      <div className="reports-wrapper">
        <div className="reports-header">
          <Title level={4} className="reports-title">
            Reports
          </Title>

          <Text className="reports-subtitle">
            Access and download your portfolio reports and documents
          </Text>
        </div>

        {/* ===== Toolbar ===== */}
        <Row
          gutter={[12, 12]}
          align="middle"
          justify="space-between"
          style={{ marginBottom: 16 }}
        >
          <Col xs={24} md={24} lg={20}>
            <Input
              placeholder="Search reports"
              prefix={<SearchOutlined />}
              allowClear
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="reports-search"
            />
          </Col>



          {/* <Col xs={24} md={4}>
            <Space style={{ width: "100%", justifyContent: "flex-end" }}>
              <Popover content={filterContent} trigger="click">
                <Button icon={<FilterOutlined />}>Filter</Button>
              </Popover>

              <Popover content={dateContent} trigger="click">
                <Button icon={<CalendarOutlined />}>Date Range</Button>
              </Popover>
            </Space>
          </Col> */}

          <Col xs={24} md={24} lg={4}>
            <div className="reports-toolbar-actions">
              <Popover content={filterContent} trigger="click">
                <Button icon={<FilterOutlined />} block>
                  Filters
                </Button>
              </Popover>

              <Popover className="reportDatePikcer" content={dateContent} trigger="click">
                <Button icon={<CalendarOutlined />} block>
                  Date
                </Button>
              </Popover>
            </div>
          </Col>

        </Row>



        {/* ===== Cards ===== */}
        {/* {filteredDocuments.map((doc) => (
          <Card key={doc.id} style={{ marginBottom: 12 }}>
            <Row justify="space-between" align="middle">
              <Col>
                <Row gutter={12} align="middle">
                  <Col>
                    {doc.type === "PDF" ? (
                      <FilePdfOutlined
                        style={{ fontSize: 24, color: "#ff4d4f" }}
                      />
                    ) : (
                      <FileExcelOutlined
                        style={{ fontSize: 24, color: "#52c41a" }}
                      />
                    )}
                  </Col>
                  <Col>
                    <Text strong>{doc.name}</Text>
                    <div style={{ fontSize: 12, color: "#888" }}>
                      {doc.type} • {dayjs(doc.date).format("MMM DD, YYYY")}
                    </div>
                  </Col>
                </Row>
              </Col>

              <Col>
                <Space>
                  <Button
                    type="primary"
                    icon={<EyeOutlined />}
                    onClick={() => handleOpen(doc)}
                  >
                    View
                  </Button>
                  <Button
                    type="primary"
                    icon={<DownloadOutlined />}
                    onClick={() => handleDownload(doc)}
                  >
                    Download
                  </Button>
                </Space>
              </Col>
            </Row>
          </Card>
        ))} */}
        {/* ===== Reports List ===== */}
        <div className="reports-list">
          {filteredDocuments.map((doc) => (
            <div key={doc.id} className="report-row">
              <div className="report-left">
                <div className="report-icon">
                  {doc.type === "PDF" ? (
                    <FilePdfOutlined />
                  ) : (
                    <FileExcelOutlined />
                  )}
                </div>

                <div className="report-meta">
                  <div className="report-title">{doc.name}</div>

                  <div className="report-subtitle">
                    <span>{doc.type}</span>
                    <span>  •</span>
                    {/* <span>{dayjs(doc.date).format("YYYY-MM-DD")}</span> */}
                    <span>{doc.createdDate}</span>
                    {/* <span>  •</span>
                    <span>{doc.size}</span> */}

                    {/* optional tag like screenshot */}
                    <span className="report-tag">Performance</span>
                  </div>
                </div>
              </div>

              <div className="report-action">
                <Button
                  type="primary"
                  icon={<EyeOutlined />}
                  className="view-btn"
                  onClick={() => handleOpen(doc)}
                >
                  View
                </Button>

                <Button
                  type="primary"
                  icon={<DownloadOutlined />}
                  className="download-btn"
                  onClick={() => handleDownload(doc)}
                >
                  Download
                </Button>
              </div>
            </div>
          ))}
        </div>

        {/* ===== Custom Report Section ===== */}
        <div className="custom-report-card">
          <div className="custom-report-text">
            <div className="custom-report-title">
              Need a custom report?
            </div>
            <div className="custom-report-subtitle">
              Contact our team to request custom reports tailored to your specific needs.
            </div>

            <Button
              type="primary"
              className="custom-report-btn"
              onClick={() => console.log("Request Custom Report")}
            >
              Request Custom Report
            </Button>
          </div>
        </div>


      </div>
    </Spin>
  );
};

export default Reports;
